const getters = {
  token: state => state.user.token,
  roles: state => state.user.roles,
  currentUser: state => state.user.currentUser,
  currentRole: state => state.user.currentRole,
  currentCompany: state => state.user.currentCompany,
  permissionRoutes: state => state.permission.permissionRoutes,
  isMobile: state => state.app.isMobile,
  lang: state => state.app.lang,
  theme: state => state.app.theme,
  color: state => state.app.color,
  multiTab: state => state.app.multiTab,
  config: state => state.app.globalConfig,
  diskSerials: state => state.app.diskSerials,
  location: state => state.app.location,
  bindDevice: state => state.app.bindDevice,
  sidebar: state => state.app.sidebar,
  filter: state => state.page.filter
}

export default getters
